/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const sendUpdatePaymentMethodEmailRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'sendUpdatePaymentMethodEmail',
  auth: 'app',
  fingerprint: 'xhLvzfsuza4v4q0mGcRWTpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const terminateContractRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'terminateContract',
  auth: 'app',
  fingerprint: 'Gszko4y6cW3AmBLe7og1R5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelScheduledTerminationRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'cancelScheduledTermination',
  auth: 'app',
  fingerprint: 'xMqPRMx3ePIc1j_QnXjPFZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRenewalQuoteRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'createRenewalQuote',
  auth: 'app',
  fingerprint: 's64RJp9-tooArZ4VUgNu2JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createChangeQuoteRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'createChangeQuote',
  auth: 'app',
  fingerprint: 'RD9o1sk6_oo6wRc2qdG-BpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllowedActionsRpc = {
  serviceName: 'com.hubspot.commerce.contracts.rpc.ContractActionService',
  rpcName: 'getAllowedActions',
  auth: 'app',
  fingerprint: 'F-ViQtQeGvQunIDSum1QjJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};